import {
  Icon,
  InputAdornment,
  InputControl,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';

import { ClockIcon } from '@tonic-one/react-icons';

const CustomTimeInput = ({
  onChange,
  value,
  ...rest
}: {
  onChange: Function;
  value: string;
  [key: string]: any;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const handleTimeInputChange = (event: any) => {
    const value = event.target.value;
    onChange(value);
  };

  return (
    <InputControl
      onChange={handleTimeInputChange}
      width={115}
      borderTopLeftRadius={0}
      borderBottomLeftRadius={0}
      startAdornment={
        <InputAdornment color={colorStyle.color.secondary}>
          <Icon as={ClockIcon} />
        </InputAdornment>
      }
      value={value}
      {...rest}
    />
  );
};

export default CustomTimeInput;
